module.exports = __webpack_public_path__ + "media/images/icons/place-red-a1958a1438864cd7b3039c707f87e1bb.png";